export default __webpack_public_path__ + "aba36c2cb0bc76214a6f8d4cfcc5b8a5.webp";